// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2f-1";
export var rateTableServiceLevelDropdown = "_2f-3";
export var rateTableTypeDropdown = "_2f-0";
export var rateTableValueModeDropdown = "_2f-2";